<template>
  <div class="zoom">
	<div class="zoom-in" @click="zoomIn()"><plus-icon/></div>
	<div class="zoom-out" @click="zoomOut()"><moins-icon/></div>
  </div>
</template>

<script>

import PlusIcon from './icons/plus.svg';
import MoinsIcon from './icons/moins.svg';

export default {
	name: 'ZoomControl',
	components: {
		PlusIcon,
		MoinsIcon,
	},
	data() {
		return {
		}
	},
	methods: {
		zoomIn() {
			this.$emit('zoom', 'in')
		},
		zoomOut() {
			this.$emit('zoom', 'out')
		}
	}
}
</script>


<style scoped lang="scss">

.zoom {
	flex-direction: column;
	align-items: center;

	> * {
		@include base-circle() {
			> * {
				fill: $picto-color;
				transform: scale(.4);
			}
		}
	}
}

</style>
